import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LogoutRedirectPage = () => {
  const navigate = useNavigate();

  const lastIdToken = sessionStorage.getItem("idToken");
  const logoutUrl = sessionStorage.getItem("logoutUrl");
  const fallbackUrl = `${window.location.origin}/auth/login`;

  const cognitoDomain = `${process.env.REACT_APP_COGNITO_DOMAIN}`;
  const cognitoClientId = `${process.env.REACT_APP_CLIENT_ID}`;

  useEffect(() => {
    if (!logoutUrl) {
      navigate("/auth/login", { replace: true });
      return;
    }

    const redirectBack = encodeURIComponent(fallbackUrl);
    const cognitoLogoutUrl = encodeURIComponent(
      `https://${cognitoDomain}/logout?client_id=${cognitoClientId}&logout_uri=${redirectBack}`
    );
    let url = `${logoutUrl}${cognitoLogoutUrl}`;

    if (lastIdToken) url += `&id_token_hint=${encodeURIComponent(lastIdToken)}`;

    window.location.assign(url);

    setTimeout(() => {
      sessionStorage.removeItem("logoutUrl");
      sessionStorage.removeItem("idToken");
    }, 1000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default LogoutRedirectPage;
